import ServiceModal from './ServiceModal';
export default ServiceModal;
export { ServiceModal } from './ServiceModal';
